import script from "./LegalDocumentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocumentsList.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocumentsList.vue?vue&type=style&index=0&id=360db2da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360db2da"]])

export default __exports__